<template>
  <div id="register">
    <h3 class="register-title van-hairline--top-bottom">注册</h3>
    <van-cell-group>
      <van-field
        v-model="mobile"
        required
        label="手机号"
        placeholder="请输入手机号"></van-field>
      <van-field
        v-model="code"
        required
        label="验证码"
        placeholder="请输入验证码"
      >
        <van-button
          :disabled="codeDisabled"
          @click="getCode"
          type="primary"
          slot="button"
          size="small"
          >获取验证码{{ count }}</van-button
        >
      </van-field>
      <van-field
        v-model="password"
        type="password"
        required
        label="密码"
        placeholder="请设置密码"></van-field>
      <van-field
        v-model="verify"
        type="password"
        required
        label="确认密码"
        placeholder="确认密码"></van-field>
      <van-field
        v-model="inviteCode"
        :disabled="isScan"
        label="邀请码"
        placeholder="请输入邀请码"></van-field>
    </van-cell-group>
    <div class="btn">
      <van-button @click="register" type="danger" size="normal"
        >注册</van-button
      >
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
import BMap from "BMap";
import { city } from "../../utils/city.js";

export default {
  name: "register",
  data() {
    return {
      userId: "",
      // 用户名
      mobile: "",
      // 验证码
      code: "",
      // 密码
      password: "",
      // 确认密码
      verify: "",
      // 验证码倒计时
      count: "",
      timer: "",
      codeDisabled: false,
      inviteCode: this.$route.query.inviteCode || '',
      isScan: !!this.$route.query.inviteCode,
      // 位置信息
      location: {
        lat: null,
        lng: null,
        province: null,
        city: null,
        district: null,
        provinceId: null,
        cityId: null,
        districtId: null
      }
    };
  },
  created() {
    this.getCurrentPosition(r => {
      this.location.province = r.address.province;
      this.location.city = r.address.city;
      this.location.district = r.address.district;
      this.location.lat = r.point.lat;
      this.location.lng = r.point.lng;
      for (let key in city.province_list) {
        if (city.province_list[key] === this.location.province) {
          this.location.provinceId = key;
        }
      }
      for (let key in city.city_list) {
        if (city.city_list[key] === this.location.city) {
          this.location.cityId = key;
        }
      }
      for (let key in city.county_list) {
        if (city.county_list[key] === this.location.district) {
          this.location.districtId = key;
        }
      }
    });
  },
  methods: {
    // 获取验证码
    getCode() {
      if (!this.mobile) {
        Dialog.alert({
          message: "请输入手机号!"
        });
        return false;
      }
      this.$axios({
        url: "user/captcha",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        },
        params: {
          mobile: this.mobile
        }
      }).then(res => {
        if (res.data.code === 200) {
          this.codeDisabled = true;
          let TIME_COUNT = 60;
          let count = TIME_COUNT;
          this.count = "(" + TIME_COUNT + ")";
          this.timer = setInterval(() => {
            if (count > 1 && count <= TIME_COUNT) {
              count--;
              this.count = "(" + count + ")";
            } else {
              clearInterval(this.timer);
              this.timer = null;
              this.codeDisabled = false;
              this.count = "";
            }
          }, 1000);
        }
      });
    },
    // 获取当前位置
    getCurrentPosition(callback) {
      let geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(
        function(r) {
          if (this.getStatus() == BMAP_STATUS_SUCCESS) {
            callback(r);
          } else {
            Toast({
              message: "获取位置信息失败，请刷新后重试",
              duration: 2000
            });
          }
        },
        { enableHighAccuracy: true }
      );
    },
    //判断是否是微信登录
    isWxLogin() {
      return (
        window.navigator.userAgent.toLowerCase().indexOf("micromessenger") !==
        -1
      );
    },
    // 微信推送
    wxLogin() {
      let params = {
        params: {
          userId: this.userId,
          loginType: 5,
          wechatMark: this.$wechatMark
        }
      };
      // 根据手机号获取openId
      this.$axios.post("weixin/get/openid", params).then(res => {
        if (res.data.code === 200) {
          if (res.data.data == null || res.data.data == "") {
            let params1 = {
              wechatMark: this.$wechatMark,
              callback: "https://yq.cg1717.com/wxCallback.html"
            };
            // 微信授权
            this.$axios
              .get("weixin/getCodeUrl", { params: params1 })
              .then(res => {
                window.location.href = res.data.data;
              });
          } else {
            this.$router.push("/preorder");
          }
        }
      });
    },
    // 注册
    register() {
      if (!this.mobile || !this.code || !this.password || !this.verify) {
        Dialog.alert({
          message: "请输入完整信息!"
        });
        return false;
      }
      if (this.verify != this.password) {
        Dialog.alert({
          message: "两次输入密码不一致!"
        });
        return false;
      }
      let params = {
        params: {
          mobile: this.mobile,
          nickname: this.mobile,
          password: this.password,
          loginType: 5,
          captcha: this.code,
          gender: 0,
          inviteCode: this.inviteCode,
          lat: this.location.lat || 0,
          lng: this.location.lng || 0,
          provinceName: this.location.province || "广东省",
          provinceId: this.location.provinceId || "440000",
          cityName: this.location.city || "广州市",
          cityId: this.location.cityId || "440100",
          districtName: this.location.district || "白云区",
          districtId: this.location.districtId || "440111"
        }
      };

      this.$axios.post("user/checkRegister", params).then(res => {
        if (res.data.code === 200) {
          this.$axios.post("user/registry", params).then(res => {
            if (res.data.code === 200) {
              let params = {
                params: {
                  loginType: 5,
                  mobile: this.mobile,
                  password: this.password
                }
              };
              this.$axios.post("auth/token", params).then(res => {
                if (res.data.code === 200) {
                  let params = {
                    params: "TRANSPORT_WAY"
                  };
                  this.$axios.post("dict/info", params).then(res => {
                    if (res.data.code === 200) {
                      let d = res.data.data;
                      d.forEach(val => {
                        val.name = val.dictName;
                      });
                      this.$store.commit({
                        type: "getDict",
                        t: "transport",
                        list: d
                      });
                    }
                  });
                  params = {
                    params: "PACK_NAME_TYPE"
                  };
                  this.$axios.post("dict/info", params).then(res => {
                    if (res.data.code === 200) {
                      let d = res.data.data;
                      d.forEach(val => {
                        val.name = val.dictName;
                      });
                      this.$store.commit({
                        type: "getDict",
                        t: "pack",
                        list: d
                      });
                    }
                  });
                  params = {
                    params: "PAY_MEANS_TYPE"
                  };
                  this.$axios.post("dict/info", params).then(res => {
                    if (res.data.code === 200) {
                      let d = res.data.data;
                      d.forEach(val => {
                        val.name = val.dictName;
                      });
                      this.$store.commit({
                        type: "getDict",
                        t: "pay",
                        list: d
                      });
                    }
                  });
                  params = {
                    params: "DELIVERY_TYPE"
                  };
                  this.$axios.post("dict/info", params).then(res => {
                    if (res.data.code === 200) {
                      let d = res.data.data;
                      d.forEach(val => {
                        val.name = val.dictName;
                      });
                      this.$store.commit({
                        type: "getDict",
                        t: "delivery",
                        list: d
                      });
                    }
                  });
                  params = {
                    params: "TRACKING_STATUS"
                  };
                  this.$axios.post("dict/info", params).then(res => {
                    if (res.data.code === 200) {
                      let d = res.data.data;
                      d.forEach(val => {
                        val.name = val.dictName;
                      });
                      this.$store.commit({
                        type: "getDict",
                        t: "status",
                        list: d
                      });
                    }
                  });
                  let data = res.data.data;
                  this.userId = data.accid;
                  localStorage.setItem(
                    "yhb_token",
                    JSON.stringify({
                      token: data.token_type + " " + data.access_token
                    })
                  );
                  localStorage.setItem("yhb_phone", this.mobile);
                  localStorage.setItem("yhb_userId", this.userId);
                  localStorage.setItem("yhb_rememberPhone", this.mobile);
                  this.$cookie.set(
                    "yhb_token",
                    JSON.stringify({
                      token: data.token_type + " " + data.access_token
                    })
                  );
                  this.$cookie.set("yhb_phone", this.mobile);
                  this.$cookie.set("yhb_userId", this.userId);
                  this.$store.commit("getToken");
                  if (this.isWxLogin()) {
                    this.wxLogin();
                  } else {
                    this.$router.push("/user");
                  }
                }
              });
            } else {
              this.$toast({
                message: res.data.msg,
                duration: 1000,
              })
            }
          });
        } else {
          Dialog.alert({
            message: "该手机号已被注册!"
          }).then(() => {
            return false;
          });
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
#register {
  .register-title {
    background-color: #fff;
    font-size: 0.45rem;
    text-align: center;
    padding: 0.425rem 0;
  }
  .btn {
    padding: 0 0.25rem;
    margin: 0.25rem 0;
    display: flex;
    justify-content: space-around;
    .van-button {
      width: 100%;
    }
  }
}
</style>
